export default __webpack_public_path__ + "static/mini-hero-service_details-df68c425d46e881bc69a88561d06310f.jpg";